import React, { Component } from "react";
import { Form, Checkbox, Header, Icon, Segment } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

class AISummaryConfiguration extends Component {
  handleCheckboxChange = (e, { name, checked }) => {
    let { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: checked });
  };

  render() {
    const { location, t } = this.props;

    return (
      <Segment>
        <Header as="h5">
          <Icon name="settings" />
          <Header.Content>{t("ai_summary").message || "AI Summary"}</Header.Content>
        </Header>
        <Segment>
          <Form>
            <Form.Field>
              <Checkbox
                checked={location.generate_ai_summary}
                name="generate_ai_summary"
                label={t("generate_ai_summary").message || "Generate AI Summary"}
                onChange={this.handleCheckboxChange}
              />
            </Form.Field>
          </Form>
        </Segment>
      </Segment>
    );
  }
}

export default withTranslation()(AISummaryConfiguration);
